import React from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { ROUTES } from "constants/index";

/** Legacy `/upgrade-payment/:id` URLs → `/upgrade?packageId=…` */
export const UpgradePaymentRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const isYearly = searchParams.get("isYearly") ?? "true";
  const qs = new URLSearchParams();
  if (id) qs.set("packageId", id);
  if (isYearly) qs.set("isYearly", isYearly);
  return (
    <Navigate
      to={`${ROUTES.UPGRADE_PACKAGE}?${qs.toString()}`}
      replace
    />
  );
};
